import {
	AddCompanyRequest,
	AtecoDto,
	CheckAtecoRequest,
	ClienteDto,
	CompanyApi,
	CompanyRequest,
	Configuration,
	SearchCompanyDto,
	SearchCompanyRequest,
	UpdateCompanyRequest,
} from "@api/client";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { appConfig } from "core/app.config";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "core/store/config";

enum CompanyReducer {
	setIdCompany = "[COMPANY] Set ID Company",
	setIdCliente = "[COMPANY] Set ID Cliente",
	setCompany = "[COMPANY] Descrizione Ateco",
	searchCompany = "[COMPANY] Search company",
	addCompany = "[COMPANY] Add company",
	getCompanyDetails = "[COMPANY] Get company Details",
	updateCompany = "[COMPANY] Update company",
	checkAteco = "[COMPANY] Check Ateco",
	descrizioneAteco = "[COMPANY] Descrizione Ateco",
}

export const companySetIdCompany = createAction<string>(CompanyReducer.setIdCompany);
export const companySetIdCliente = createAction<string>(CompanyReducer.setIdCliente);
export const companySetCompany = createAction<ClienteDto>(CompanyReducer.setCompany);

export const companyDescrizioneAteco = createAction<string>(CompanyReducer.descrizioneAteco);

export const companySearchCompany = createAsyncThunk<
	SearchCompanyDto | undefined,
	string,
	ThunkApiConfig
>(CompanyReducer.searchCompany, async (searchText, { dispatch, extra, getState }) => {
	try {
		let request: SearchCompanyRequest = {
			searchText,
			isTest: appConfig.isTest,
		};

		return await new CompanyApi(getConfiguration(Configuration, extra, getState)).searchCompany(
			request
		);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const companyAddCompany = createAsyncThunk<ClienteDto | undefined, string, ThunkApiConfig>(
	CompanyReducer.addCompany,
	async (idSoggetto, { dispatch, extra, getState }) => {
		try {
			let idPratica = getState()?.pratica?.idPratica;

			if (!idPratica) return;

			let request: AddCompanyRequest = {
				idPratica,
				idSoggetto,
				isTest: appConfig.isTest,
			};

			return await new CompanyApi(getConfiguration(Configuration, extra, getState))
				.addCompany(request)
				.then((res) => {
					if (res?.idSoggetto) dispatch(companySetIdCompany(res?.idSoggetto));
					if (res?.idCliente) dispatch(companySetIdCliente(res?.idCliente));

					return res;
				});
		} catch (e) {
			errorHandler(e, dispatch);
		}
	}
);

export const companyGetCompanyDetails = createAsyncThunk<
	ClienteDto | undefined,
	void,
	ThunkApiConfig
>(CompanyReducer.getCompanyDetails, async (_, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;

		if (!idPratica) return;

		let request: CompanyRequest = {
			idPratica,
		};

		return await new CompanyApi(getConfiguration(Configuration, extra, getState))
			.company(request)
			.then((res) => {
				if (res?.idSoggetto) dispatch(companySetIdCompany(res?.idSoggetto));
				if (res?.idCliente) dispatch(companySetIdCliente(res?.idCliente));
				if (res) dispatch(companySetCompany(res));
				return res;
			});
	} catch (e) {
		// errorHandler(e, dispatch);
	}
});

export const companyUpdateCompany = createAsyncThunk<
	ClienteDto | undefined,
	ClienteDto,
	ThunkApiConfig
>(CompanyReducer.updateCompany, async (company, { dispatch, extra, getState }) => {
	try {
		let request: UpdateCompanyRequest = {
			clienteDto: company,
		};

		return await new CompanyApi(getConfiguration(Configuration, extra, getState))
			.updateCompany(request)
			.then((res) => {
				if (res?.idSoggetto) dispatch(companySetIdCompany(res?.idSoggetto));
				if (res?.idCliente) dispatch(companySetIdCliente(res?.idCliente));
				if (res) dispatch(companySetCompany(res));

				return res;
			});
	} catch (error) {
		errorHandler(error, dispatch);
	}
});

export const companyCheckAteco = createAsyncThunk<AtecoDto | undefined, string, ThunkApiConfig>(
	CompanyReducer.checkAteco,
	async (codiceAteco, { dispatch, extra, getState }) => {
		try {
			let request: CheckAtecoRequest = {
				codiceAteco,
			};

			return await new CompanyApi(getConfiguration(Configuration, extra, getState)).checkAteco(
				request
			);
		} catch (e) {
			errorHandler(e, dispatch);
		}
	}
);
